// import React from "react";
import { Link } from "react-router-dom";
// import { useNavigate } from "react-router-dom";

// import Col from "react-bootstrap/Col";
// import Button from "react-bootstrap/Button";

import "./SimpleNavigationButton.css";

function SimpleNavigationButton({ label, path, colour }) {
  // let navigate = useNavigate();
  return (
    <Link to={path}>
      <img
        src={process.env.PUBLIC_URL + "/assets/imgs/arrow-left.svg"}
        alt="Back"
        className="back-arrow"
        // onClick={() => navigate(-1)}
        style={{ cursor: "pointer" }}
      />
    </Link>
  );
}

export default SimpleNavigationButton;
